// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DNczSsoZlJuTvn {
  height: 100%;
  margin-bottom: var(--ds-space-150, 12px);
  padding: var(--ds-space-0, 0) var(--ds-space-150, 10px);
  overflow: hidden;
  background: transparent;
  color: var(--dynamic-text);
  font-size: 18px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 32px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.TZ0SWa_GMC0csv {
  font-size: 16px;
}
.a_tCby5RhTa2g9 .rjY2KOSzslBciY {
  display: block;
  box-sizing: border-box;
}
.a_tCby5RhTa2g9 .DNczSsoZlJuTvn {
  display: none;
}
.lWkxYS_6YVpYsA:hover,
.lWkxYS_6YVpYsA:focus {
  background-color: var(--dynamic-button-hovered);
  color: var(--dynamic-text);
  cursor: pointer;
}
.lWkxYS_6YVpYsA:hover svg circle,
.lWkxYS_6YVpYsA:focus svg circle {
  stroke: var(--dynamic-icon);
}
.yFR8tC0K4fD6K5 {
  display: inline-flex;
  position: relative;
  max-width: 100%;
  height: 32px;
  margin-right: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-0, 0);
  border-radius: var(--ds-border-radius-100, 3px);
  line-height: 32px;
  white-space: nowrap;
  cursor: default;
}
.snhoDr8fQxJuO0 {
  overflow: hidden;
}
.nzHJ2eMJnY2t62 .a_tCby5RhTa2g9 .rjY2KOSzslBciY {
  display: block;
}
.nzHJ2eMJnY2t62 .a_tCby5RhTa2g9 .DNczSsoZlJuTvn {
  display: none;
}
.rjY2KOSzslBciY {
  display: none;
  height: 32px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-150, 10px);
  border: 0;
  background-color: var(--ds-background-input, #ffffff);
  font-size: 18px;
  font-weight: var(--ds-font-weight-bold, bold);
}
.rjY2KOSzslBciY:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
`, ""]);
// Exports
export var boardName = `DNczSsoZlJuTvn`;
export var boardNameSmall = `TZ0SWa_GMC0csv`;
export var isEditing = `a_tCby5RhTa2g9`;
export var boardNameInput = `rjY2KOSzslBciY`;
export var boardNameRenamable = `lWkxYS_6YVpYsA`;
export var boardNameContainer = `yFR8tC0K4fD6K5`;
export var boardNameContainerNoOverflow = `snhoDr8fQxJuO0`;
export var boardNameContaner = `nzHJ2eMJnY2t62`;
export default ___CSS_LOADER_EXPORT___;
